import React from "react";
import { formatDate, formatDateTime, formatPhoneNumber } from "../../functions/util/format";
import "./voicemail-stats-styling.css";

const STATUS_LABELS = {
  pending: "Pending",
  notified: "Notified",
  resolved: "Resolved",
  excluded: "Excluded",
};

const VoicemailNotificationLogsContainer = ({
  logs,
  statusFilter,
  onStatusFilterChange,
}) => {
  return (
    <div className="vm-stats-logs-container">
      <div className="vm-stats-logs-header">
        <p className="comm-title">Notification Logs</p>
        <select
          className="vm-stats-status-select"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
        >
          <option value="">All Statuses</option>
          <option value="pending">Pending</option>
          <option value="notified">Notified</option>
          <option value="resolved">Resolved</option>
          <option value="excluded">Excluded</option>
        </select>
      </div>
      {logs.length > 0 ? (
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th className="table-heading">Office</th>
                <th className="table-heading">Office Sys Name</th>
                <th className="table-heading">From</th>
                <th className="table-heading">Tag</th>
                <th className="table-heading">Status</th>
                <th className="table-heading">Received</th>
                <th className="table-heading">Deadline</th>
                <th className="table-heading">Notified At</th>
                <th className="table-heading">Resolved At</th>
                <th className="table-heading">Assigned To</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log._id}>
                  <td className="table-item">
                    {log.officeId?.officeName || "—"}
                  </td>
                  <td className="table-item">
                    {log.officeId?.officeSysName || "—"}
                  </td>
                  <td className="table-item">
                    {log.voicemailId?.from
                      ? formatPhoneNumber(log.voicemailId.from)
                      : "—"}
                  </td>
                  <td className="table-item">
                    {log.voicemailId?.tag || "—"}
                  </td>
                  <td className="table-item">
                    {STATUS_LABELS[log.status] || log.status}
                  </td>
                  <td className="table-item">
                    {log.receivedAt ? formatDate(log.receivedAt) : "—"}
                  </td>
                  <td className="table-item">
                    {log.deadlineAt ? formatDateTime(log.deadlineAt) : "—"}
                  </td>
                  <td className="table-item">
                    {log.notificationSentAt
                      ? formatDateTime(log.notificationSentAt)
                      : "—"}
                  </td>
                  <td className="table-item">
                    {log.resolvedAt ? formatDateTime(log.resolvedAt) : "—"}
                  </td>
                  <td className="table-item">
                    {log.assignedTo
                      ? `${log.assignedTo.firstName} ${log.assignedTo.lastName}`
                      : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No notification logs to display.</p>
      )}
    </div>
  );
};

export default VoicemailNotificationLogsContainer;
